import React from 'react';
import { Card, CardProps } from './Card';

export interface SectionProps extends Omit<CardProps, 'children'> {
  /** Big section heading shown at the top. */
  title?: React.ReactNode;
  /** Optional icon node placed before the title (e.g. <FeatherIcon icon="shield"/>). */
  icon?: React.ReactNode;
  /** Small grey subtitle under the title — for things like "Източник: НЗИС". */
  subtitle?: React.ReactNode;
  /** Right-aligned action area (buttons, link). */
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Card with a standard heading bar. Use when the block has a clear title.
 * For body-only cards (no title), use <Card> directly.
 */
export const Section: React.FC<SectionProps> = ({
  title, icon, subtitle, actions, children, ...cardProps
}) => {
  return (
    <Card {...cardProps}>
      {(title || actions) && (
        <header className="vc-section__head">
          <div className="vc-section__titles">
            {title && (
              <h3 className="vc-section__title">
                {icon && <span className="vc-section__icon">{icon}</span>}
                <span>{title}</span>
              </h3>
            )}
            {subtitle && <div className="vc-section__subtitle">{subtitle}</div>}
          </div>
          {actions && <div className="vc-section__actions">{actions}</div>}
        </header>
      )}
      {children}
    </Card>
  );
};
